import React from 'react'
import { AppCompaniesChoices } from "src/types"
import { buildCompanyLogoLink, getStyles } from "src/helpers"
import './CompanyLogo.scss'

interface ICompanyLogo extends React.HTMLAttributes<HTMLImageElement> {
    name: keyof typeof AppCompaniesChoices
    mode: "main" | "chat"
}

const CompanyLogo: React.FC<ICompanyLogo> = (props) => {
    const { name, mode, className } = props

    const styles = getStyles("company-logo", [
        mode,
        {
            decision: name === "sport-master",
            name: "sport-master-logo"
        }
    ], className)

    return (
        <img
            src={buildCompanyLogoLink(name, mode)}
            className={styles}
            alt=""
        />
    )
}

export default CompanyLogo